import { useTenantSettingStore } from "../../store/useTenantSettingStore";
import { findFeatureFlagForUrl } from "./featureFlagUrlMap";

export function useFeatureFlags() {
  const { tenantSettings } = useTenantSettingStore();
  const tenantFlags = tenantSettings?.tenantFeatureFlags ?? [];

  const isTenantFeatureEnabled = (featureFlag: string | null) => {
    if (!featureFlag) return true; // no mapping -> route always configured
    const flag = tenantFlags.find((f) => f.featureFlag.name === featureFlag);
    if (!flag) return false; // feature not configured
    return flag.isEnabled;
  };

  const isUrlEnabled = (path: string) => {
    const featureName = findFeatureFlagForUrl(path);
    return isTenantFeatureEnabled(featureName);
  };
  
  return { isUrlEnabled, isTenantFeatureEnabled };
}
